import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbles"><Path fillRule="evenodd" clipRule="evenodd" d="M6.25195 3H22.002V15H18.002V19H10.6963L5.25195 22.0246V19H2.00195V7H6.25195V3ZM7.75195 7H18.002V13.5H20.502V4.5H7.75195V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbles;
